import { render, staticRenderFns } from "./tradePwd.vue?vue&type=template&id=450e80d6&"
import script from "./tradePwd.vue?vue&type=script&lang=js&"
export * from "./tradePwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports